// src/components/NotificacaoAcademica/NotificacaoList.jsx
import React, { useEffect, useState } from 'react';
import { listarNotificacoes, marcarComoLida, excluirNotificacao } from '../../services/notificacaoAcademicaService';
import { useAuth } from '../../hooks/useAuth';

const NotificacaoList = () => {
    const { user } = useAuth();
    const [notificacoes, setNotificacoes] = useState([]);

    useEffect(() => {
        if (user) {
            listarNotificacoes(user.id).then(response => {
                setNotificacoes(response.data);
            });
        }
    }, [user]);

    const handleMarcarComoLida = async (id) => {
        await marcarComoLida(id);
        setNotificacoes(notificacoes.map(n => n.id === id ? { ...n, lida: true } : n));
    };

    const handleExcluir = async (id) => {
        await excluirNotificacao(id);
        setNotificacoes(notificacoes.filter(n => n.id !== id));
    };

    return (
        <div>
            <h2>Notificações Acadêmicas</h2>
            <ul>
                {notificacoes.map(notificacao => (
                    <li key={notificacao.id} style={{ textDecoration: notificacao.lida ? 'line-through' : 'none' }}>
                        <strong>{notificacao.titulo}</strong>: {notificacao.conteudo}
                        <button onClick={() => handleMarcarComoLida(notificacao.id)}>Marcar como lida</button>
                        <button onClick={() => handleExcluir(notificacao.id)}>Excluir</button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default NotificacaoList;